import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
var f = class extends t {
	instance;
	baseUrl;
	jsonParseReviver = void 0;
	constructor(e, t) {
		super(), this.instance = t || n.create(), this.baseUrl = e ?? "http://127.0.0.1:7091/Crm";
	}
	exportCrmNetworkItemizedTransactions(e, t) {
		let n = this.baseUrl + "/ExportCrmNetworkItemizedTransactions";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "text/csv"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processExportCrmNetworkItemizedTransactions(e)));
	}
	processExportCrmNetworkItemizedTransactions(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmContractCommissionDiscrepancies(e, t) {
		let n = this.baseUrl + "/GetCrmContractCommissionDiscrepancies?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCrmContractCommissionDiscrepancies(e)));
	}
	processGetCrmContractCommissionDiscrepancies(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmCurrentPartnershipInformation(e, t) {
		let n = this.baseUrl + "/GetCrmCurrentPartnershipInformation?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCrmCurrentPartnershipInformation(e)));
	}
	processGetCrmCurrentPartnershipInformation(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmEntityNumbers(e, t) {
		let n = this.baseUrl + "/GetCrmEntityNumbers";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCrmEntityNumbers(e)));
	}
	processGetCrmEntityNumbers(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmExecutiveKeyMetrics(e, t) {
		let n = this.baseUrl + "/GetCrmExecutiveKeyMetrics?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCrmExecutiveKeyMetrics(e)));
	}
	processGetCrmExecutiveKeyMetrics(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmExecutiveRunRateMetrics(e, t) {
		let n = this.baseUrl + "/GetCrmExecutiveRunRateMetrics?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCrmExecutiveRunRateMetrics(e)));
	}
	processGetCrmExecutiveRunRateMetrics(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmLeaderboardStatisticsForEntity(e, t) {
		let n = this.baseUrl + "/GetCrmLeaderboardStatisticsForEntity";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCrmLeaderboardStatisticsForEntity(e)));
	}
	processGetCrmLeaderboardStatisticsForEntity(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmListingDiscrepancies(e, t) {
		let n = this.baseUrl + "/GetCrmListingDiscrepancies?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCrmListingDiscrepancies(e)));
	}
	processGetCrmListingDiscrepancies(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmNetworkPartnershipMetrics(e, t) {
		let n = this.baseUrl + "/GetCrmNetworkPartnershipMetrics";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCrmNetworkPartnershipMetrics(e)));
	}
	processGetCrmNetworkPartnershipMetrics(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmNetworkStateMetrics(e, t) {
		let n = this.baseUrl + "/GetCrmNetworkStateMetrics";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCrmNetworkStateMetrics(e)));
	}
	processGetCrmNetworkStateMetrics(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmPartnershipInformation(e, t) {
		let n = this.baseUrl + "/GetCrmPartnershipInformation";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCrmPartnershipInformation(e)));
	}
	processGetCrmPartnershipInformation(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmStaffLeaderboardStatistics(e, t) {
		let n = this.baseUrl + "/GetCrmStaffLeaderboardStatistics?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCrmStaffLeaderboardStatistics(e)));
	}
	processGetCrmStaffLeaderboardStatistics(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmStatisticsForEntity(e, t) {
		let n = this.baseUrl + "/GetCrmStatisticsForEntity";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCrmStatisticsForEntity(e)));
	}
	processGetCrmStatisticsForEntity(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmTopPerformers(e, t) {
		let n = this.baseUrl + "/GetCrmTopPerformers?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCrmTopPerformers(e)));
	}
	processGetCrmTopPerformers(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmUpcomingSettlementsForAgency(e, t) {
		let n = this.baseUrl + "/GetCrmUpcomingSettlementsForAgency?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCrmUpcomingSettlementsForAgency(e)));
	}
	processGetCrmUpcomingSettlementsForAgency(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	crmProviderWebhook(e, t, n) {
		let r = this.baseUrl + "/CrmProviderWebhook?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processCrmProviderWebhook(e)));
	}
	processCrmProviderWebhook(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmActiveListingsForAgency(e, t) {
		let n = this.baseUrl + "/GetCrmActiveListingsForAgency?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCrmActiveListingsForAgency(e)));
	}
	processGetCrmActiveListingsForAgency(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmAgencyListingsPermanentLinkModel(e, t) {
		let n = this.baseUrl + "/GetCrmAgencyListingsPermanentLinkModel?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCrmAgencyListingsPermanentLinkModel(e)));
	}
	processGetCrmAgencyListingsPermanentLinkModel(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmListingByCampaignId(e, t, n) {
		let r = this.baseUrl + "/GetCrmListingByCampaignId?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		if (r += "agencyId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmListingByCampaignId(e)));
	}
	processGetCrmListingByCampaignId(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmSuburbs(e, t) {
		let n = this.baseUrl + "/GetCrmSuburbs";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCrmSuburbs(e)));
	}
	processGetCrmSuburbs(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	setCrmListingPublishedToPortal(e, t) {
		let n = this.baseUrl + "/SetCrmListingPublishedToPortal";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSetCrmListingPublishedToPortal(e)));
	}
	processSetCrmListingPublishedToPortal(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmPublishedListingDetail(e, t, n) {
		let r = this.baseUrl + "/GetCrmPublishedListingDetail?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		if (r += "agencyId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'listingId' must be defined and cannot be null.");
		r += "listingId=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmPublishedListingDetail(e)));
	}
	processGetCrmPublishedListingDetail(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmPublishedListingDetails(e, t) {
		let n = this.baseUrl + "/GetCrmPublishedListingDetails";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCrmPublishedListingDetails(e)));
	}
	processGetCrmPublishedListingDetails(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmPublishedListingsAgentsAndSuburbs(e, t) {
		let n = this.baseUrl + "/GetCrmPublishedListingsAgentsAndSuburbs?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCrmPublishedListingsAgentsAndSuburbs(e)));
	}
	processGetCrmPublishedListingsAgentsAndSuburbs(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	createCrmLead(e, t) {
		let n = this.baseUrl + "/CreateCrmLead";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processCreateCrmLead(e)));
	}
	processCreateCrmLead(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	connectCrmAgencyProvider(e, t) {
		let n = this.baseUrl + "/ConnectCrmAgencyProvider";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processConnectCrmAgencyProvider(e)));
	}
	processConnectCrmAgencyProvider(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 409) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 429) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 503) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	disconnectCrmAgencyProvider(e, t) {
		let n = this.baseUrl + "/DisconnectCrmAgencyProvider";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processDisconnectCrmAgencyProvider(e)));
	}
	processDisconnectCrmAgencyProvider(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 409) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmAgencyConnectionDetails(e, t) {
		let n = this.baseUrl + "/GetCrmAgencyConnectionDetails?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCrmAgencyConnectionDetails(e)));
	}
	processGetCrmAgencyConnectionDetails(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 409) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCrmAgentDetails(e, t, n) {
		let r = this.baseUrl + "/GetCrmAgentDetails?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		if (r += "agencyId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'agentId' must be defined and cannot be null.");
		r += "agentId=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmAgentDetails(e)));
	}
	processGetCrmAgentDetails(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	updateCrmAgentDetails(e, t) {
		let n = this.baseUrl + "/UpdateCrmAgentDetails";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "PUT",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (z(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processUpdateCrmAgentDetails(e)));
	}
	processUpdateCrmAgentDetails(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return R("No description", t, r, n);
		} else if (t === 501) {
			let r = e.data, i = null;
			return i = r, R("Payload of CrmResultMetadata", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return R("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
}, p = /* @__PURE__ */ function(e) {
	return e.Rex = "Rex", e.Agentbox = "Agentbox", e.BoxAndDice = "BoxAndDice", e.Vault = "Vault", e;
}({}), m = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.Rex = "Rex", e.Agentbox = "Agentbox", e.BoxAndDice = "BoxAndDice", e.Vault = "Vault", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.Rex = "Rex", e.Agentbox = "Agentbox", e.BoxAndDice = "BoxAndDice", e.Vault = "Vault", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.NotConnected = "NotConnected", e.Connected = "Connected", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.Rex = "Rex", e.Agentbox = "Agentbox", e.BoxAndDice = "BoxAndDice", e.Vault = "Vault", e;
}({}), te = /* @__PURE__ */ function(e) {
	return e.NotConnected = "NotConnected", e.Connected = "Connected", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.Silver = "Silver", e.Gold = "Gold", e.Platinum = "Platinum", e.XPartner = "XPartner", e.Bronze = "Bronze", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.Written = "Written", e.Unconditional = "Unconditional", e.Settled = "Settled", e.ExpectedSettlement = "ExpectedSettlement", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.WholeNumber = "WholeNumber", e.Currency = "Currency", e.Percentage = "Percentage", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.VirtualTour = "VirtualTour", e.VideoLink = "VideoLink", e.InteractiveFloorPlan = "InteractiveFloorPlan", e.MiniWeb = "MiniWeb", e.ExternalLink = "ExternalLink", e.Unknown = "Unknown", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.Silver = "Silver", e.Gold = "Gold", e.Platinum = "Platinum", e.XPartner = "XPartner", e.Bronze = "Bronze", e;
}({}), k = /* @__PURE__ */ function(e) {
	return e.Warning = "Warning", e.Error = "Error", e;
}({}), A = /* @__PURE__ */ function(e) {
	return e.Available = "Available", e.UnderOffer = "UnderOffer", e.Sold = "Sold", e;
}({}), j = /* @__PURE__ */ function(e) {
	return e.Current = "Current", e.Sold = "Sold", e.Withdrawn = "Withdrawn", e.Leased = "Leased", e;
}({}), M = /* @__PURE__ */ function(e) {
	return e[e._0 = 0] = "_0", e[e._1 = 1] = "_1", e[e._2 = 2] = "_2", e[e._3 = 3] = "_3", e;
}({}), N = /* @__PURE__ */ function(e) {
	return e.Rex = "Rex", e.Agentbox = "Agentbox", e.BoxAndDice = "BoxAndDice", e.Vault = "Vault", e;
}({}), P = /* @__PURE__ */ function(e) {
	return e.WholeNumber = "WholeNumber", e.Currency = "Currency", e.Percentage = "Percentage", e;
}({}), F = /* @__PURE__ */ function(e) {
	return e.Rex = "Rex", e.Agentbox = "Agentbox", e.BoxAndDice = "BoxAndDice", e.Vault = "Vault", e;
}({}), I = /* @__PURE__ */ function(e) {
	return e[e._0 = 0] = "_0", e[e._1 = 1] = "_1", e[e._2 = 2] = "_2", e[e._3 = 3] = "_3", e[e._4 = 4] = "_4", e[e._5 = 5] = "_5", e[e._6 = 6] = "_6", e[e._7 = 7] = "_7", e;
}({}), L = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isCrmApiException = !0;
	static isCrmApiException(e) {
		return e.isCrmApiException === !0;
	}
};
function R(e, t, n, r, i) {
	throw i ?? new L(e, t, n, r, null);
}
function z(e) {
	return e && e.isAxiosError === !0;
}
//#endregion
//#region src/useClientContext.tsx
var B = "crm";
function V(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var H = (e, t, n) => {
	let r = new f(e);
	return r.setAuthConfig(t, n), V(r);
}, U = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.crm || `${e}/crm`;
}, W = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = U(i), u = c, d = H(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		p(H(l, a, i));
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, G = a({}), K = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = W(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(G.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, q = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(G), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.exportCrmNetworkItemizedTransactions(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		exportCrmNetworkItemizedTransactions: u,
		exportCrmNetworkItemizedTransactionsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, J = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmContractCommissionDiscrepancies", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmContractCommissionDiscrepancies(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Y = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmContractCommissionDiscrepancies", e] });
	}, e[0] = t, e[1] = n), n;
}, X = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmCurrentPartnershipInformation", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmCurrentPartnershipInformation(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Z = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmCurrentPartnershipInformation", e] });
	}, e[0] = t, e[1] = n), n;
}, Q = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(G), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.getCrmEntityNumbers(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		getCrmEntityNumbers: u,
		getCrmEntityNumbersPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ne = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmExecutiveKeyMetrics", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmExecutiveKeyMetrics(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, re = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmExecutiveKeyMetrics", e] });
	}, e[0] = t, e[1] = n), n;
}, ie = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmExecutiveRunRateMetrics", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmExecutiveRunRateMetrics(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ae = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmExecutiveRunRateMetrics", e] });
	}, e[0] = t, e[1] = n), n;
}, oe = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(G), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.getCrmLeaderboardStatisticsForEntity(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		getCrmLeaderboardStatisticsForEntity: u,
		getCrmLeaderboardStatisticsForEntityPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, se = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmListingDiscrepancies", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmListingDiscrepancies(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ce = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmListingDiscrepancies", e] });
	}, e[0] = t, e[1] = n), n;
}, le = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(G), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.getCrmNetworkPartnershipMetrics(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		getCrmNetworkPartnershipMetrics: u,
		getCrmNetworkPartnershipMetricsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ue = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(G), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.getCrmNetworkStateMetrics(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		getCrmNetworkStateMetrics: u,
		getCrmNetworkStateMetricsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, de = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(G), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.getCrmPartnershipInformation(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		getCrmPartnershipInformation: u,
		getCrmPartnershipInformationPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, fe = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmStaffLeaderboardStatistics", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmStaffLeaderboardStatistics(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, pe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmStaffLeaderboardStatistics", e] });
	}, e[0] = t, e[1] = n), n;
}, me = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(G), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.getCrmStatisticsForEntity(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		getCrmStatisticsForEntity: u,
		getCrmStatisticsForEntityPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, he = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmTopPerformers", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmTopPerformers(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ge = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmTopPerformers", e] });
	}, e[0] = t, e[1] = n), n;
}, _e = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmUpcomingSettlementsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmUpcomingSettlementsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ve = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmUpcomingSettlementsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, ye = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(G), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { agencyId: t, body: n } = e;
		return a.crmProviderWebhook(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		crmProviderWebhook: u,
		crmProviderWebhookPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, be = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmActiveListingsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmActiveListingsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, xe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmActiveListingsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, Se = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmAgencyListingsPermanentLinkModel", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmAgencyListingsPermanentLinkModel(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ce = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmAgencyListingsPermanentLinkModel", e] });
	}, e[0] = t, e[1] = n), n;
}, we = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(G), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getCrmListingByCampaignId",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getCrmListingByCampaignId(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, Te = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getCrmListingByCampaignId",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, Ee = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(G), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.getCrmSuburbs(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		getCrmSuburbs: u,
		getCrmSuburbsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, De = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(G), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.setCrmListingPublishedToPortal(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		setCrmListingPublishedToPortal: u,
		setCrmListingPublishedToPortalPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, $ = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(G), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getCrmPublishedListingDetail",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getCrmPublishedListingDetail(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, Oe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getCrmPublishedListingDetail",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, ke = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(G), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.getCrmPublishedListingDetails(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		getCrmPublishedListingDetails: u,
		getCrmPublishedListingDetailsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ae = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmPublishedListingsAgentsAndSuburbs", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmPublishedListingsAgentsAndSuburbs(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, je = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmPublishedListingsAgentsAndSuburbs", e] });
	}, e[0] = t, e[1] = n), n;
}, Me = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(G), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.createCrmLead(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		createCrmLead: u,
		createCrmLeadPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ne = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(G), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.connectCrmAgencyProvider(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		connectCrmAgencyProvider: u,
		connectCrmAgencyProviderPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Pe = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(G), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.disconnectCrmAgencyProvider(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		disconnectCrmAgencyProvider: u,
		disconnectCrmAgencyProviderPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Fe = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmAgencyConnectionDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmAgencyConnectionDetails(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ie = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmAgencyConnectionDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, Le = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(G), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getCrmAgentDetails",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== t || i[5] !== s ? (d = (n) => {
		let { signal: r } = n;
		return s.getCrmAgentDetails(e, t, r);
	}, i[3] = e, i[4] = t, i[5] = s, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, Re = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getCrmAgentDetails",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, ze = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(G), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.updateCrmAgentDetails(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateCrmAgentDetails: u,
		updateCrmAgentDetailsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
};
//#endregion
export { p as ConnectCrmAgencyProviderRequestProvider, m as CrmAgencyConnectionCapabilityResponseConnectionManagement, v as CrmAgencyConnectionCapabilityResponseInvoices, h as CrmAgencyConnectionCapabilityResponseListingRead, g as CrmAgencyConnectionCapabilityResponseListingWrite, b as CrmAgencyConnectionCapabilityResponseReporting, y as CrmAgencyConnectionCapabilityResponseTrustAccounting, _ as CrmAgencyConnectionCapabilityResponseWebhooks, x as CrmAgencyConnectionDetailsResponseActiveProvider, S as CrmAgencyConnectionProviderResponseProvider, C as CrmAgencyConnectionProviderResponseStatus, ee as CrmAgencyProviderConnectionResponseProvider, te as CrmAgencyProviderConnectionResponseStatus, G as CrmApiContext, L as CrmApiException, K as CrmApiProvider, f as CrmClient, w as CrmCurrentReviewPeriodPartnershipInformationPartnershipLevel, T as CrmExecutiveMetricsResponseContractType, E as CrmKeyMetricMetricType, D as CrmListingLinkLinkType, O as CrmPartnershipInformationPartnershipLevel, k as CrmProviderDiagnosticResponseSeverity, j as CrmPublishedListingModelListingState, A as CrmPublishedListingModelOverridenListingStatus, N as CrmResultMetadataProviderKind, M as CrmResultMetadataStatus, B as CrmRoute, P as CrmRunRateMetricMetricType, F as DisconnectCrmAgencyProviderRequestProvider, I as JsonElementValueKind, Ne as useConnectCrmAgencyProvider, Me as useCreateCrmLead, W as useCrmClientContext, ye as useCrmProviderWebhook, Pe as useDisconnectCrmAgencyProvider, q as useExportCrmNetworkItemizedTransactions, be as useGetCrmActiveListingsForAgency, Fe as useGetCrmAgencyConnectionDetails, Se as useGetCrmAgencyListingsPermanentLinkModel, Le as useGetCrmAgentDetails, J as useGetCrmContractCommissionDiscrepancies, X as useGetCrmCurrentPartnershipInformation, Q as useGetCrmEntityNumbers, ne as useGetCrmExecutiveKeyMetrics, ie as useGetCrmExecutiveRunRateMetrics, oe as useGetCrmLeaderboardStatisticsForEntity, we as useGetCrmListingByCampaignId, se as useGetCrmListingDiscrepancies, le as useGetCrmNetworkPartnershipMetrics, ue as useGetCrmNetworkStateMetrics, de as useGetCrmPartnershipInformation, $ as useGetCrmPublishedListingDetail, ke as useGetCrmPublishedListingDetails, Ae as useGetCrmPublishedListingsAgentsAndSuburbs, fe as useGetCrmStaffLeaderboardStatistics, me as useGetCrmStatisticsForEntity, Ee as useGetCrmSuburbs, he as useGetCrmTopPerformers, _e as useGetCrmUpcomingSettlementsForAgency, xe as useInvalidateUseGetCrmActiveListingsForAgency, Ie as useInvalidateUseGetCrmAgencyConnectionDetails, Ce as useInvalidateUseGetCrmAgencyListingsPermanentLinkModel, Re as useInvalidateUseGetCrmAgentDetails, Y as useInvalidateUseGetCrmContractCommissionDiscrepancies, Z as useInvalidateUseGetCrmCurrentPartnershipInformation, re as useInvalidateUseGetCrmExecutiveKeyMetrics, ae as useInvalidateUseGetCrmExecutiveRunRateMetrics, Te as useInvalidateUseGetCrmListingByCampaignId, ce as useInvalidateUseGetCrmListingDiscrepancies, Oe as useInvalidateUseGetCrmPublishedListingDetail, je as useInvalidateUseGetCrmPublishedListingsAgentsAndSuburbs, pe as useInvalidateUseGetCrmStaffLeaderboardStatistics, ge as useInvalidateUseGetCrmTopPerformers, ve as useInvalidateUseGetCrmUpcomingSettlementsForAgency, De as useSetCrmListingPublishedToPortal, ze as useUpdateCrmAgentDetails };
